<div class="form__infos" [formGroup]="formGroup">
  <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
    <mat-label>Courriel générique sur Paris 8 - @{{DOMAIN_PARIS8}}</mat-label>
    <input matInput
           type="email"
           maxlength="250"
           formControlName="email_generic"
           matTooltip="le courriel doit être de la forme mon_courriel@{{DOMAIN_PARIS8}}, les nofifications seront également envoyées à cette adresse, en plus des gestionnaires"
           placeholder="moncourriel@{{DOMAIN_PARIS8}}">
    <mat-hint align="end"><code>{{email_generic?.value?.length || 0}}</code> / <code>{{250}}</code></mat-hint>
    <mat-error *ngIf="email_generic.invalid && (email_generic.dirty || email_generic.touched)">{{getEmailErrorMessage()}}</mat-error>
  </mat-form-field>
</div>
